
export function Column(props) {
    return (
        <div className="column">
            {props.children}
        </div>
    )
}